import { createRender } from './types';

// eslint-disable-next-line formatjs/no-literal-string-in-jsx
export const render = createRender(() => <button>This is an example test button</button>);

export default render;
